import { Transform } from "../../../../geometry/transformation";
import { sharedEditorCanvas, sharedRubberCanvas, sharedPointMapperRef, DrawOptions } from "../../interface/pointMappings";
//import { recalculateShape } from "../../util/shapeEdit";
//todo: check and remove if not needed...
import { /*hitStrokeCorrection,*/ strokeCorrection } from "../../util/strokeCorrection";
import { RubberDataBase, registerInteractionHandlers, ShapeInteractionHandlers } from "../interactionManager";
import * as Global from "../../../../global"
import { /*orthogonalIntersection,*/ angleBetween, subtract, length, transformByScalingAndRotation } from "../../../../geometry/geometry"
import { hitManager } from "../hitManager"
import { GlobalImageRepository } from "../GlobalImageRepository";

export interface SymbolRubberData extends RubberDataBase {
    points: Point2d[],
    imageKey: string,
    rot: number,
    scale: number,
    anchor: AnchorType,
}

declare module "../interactionManager" {
  interface ShapeActionHandlersMap {
    symbol: ToolEntries & {
      create: {
        rubberData: SymbolRubberData;
        settings: SymbolShape;
      };
      move: {
        rubberData: SymbolRubberData;
        settings: SymbolShape;
      }
      scale: {
        rubberData: SymbolRubberData;
        settings: SymbolShape;
      }
    };
  }
}

const calcRefPoints = (symbol: SymbolShape): Point2d[] => {
    //const t = new Transform(symbol.transformation);
    //const refPoint = t.point2d({ x: symbol.x, y: symbol.y });

    let dx: number = 0;
    let dy: number = 0;
    if (symbol.anchor.horizontal === "left") dx = symbol.width / 2 * symbol.scale;
    if (symbol.anchor.horizontal === "center") dx = 0;
    if (symbol.anchor.horizontal === "right") dx = -symbol.width / 2 * symbol.scale;
    if (symbol.anchor.vertical === "top") dy = -symbol.height / 2 * symbol.scale;
    if (symbol.anchor.vertical === "center") dy = 0;
    if (symbol.anchor.vertical === "bottom") dy = symbol.height / 2 * symbol.scale;

    let points: Point2d[] = [];
    // points.push({ x: refPoint.x + dx * symbol.scale, y: refPoint.y + dy * symbol.scale });
    // points.push({ x: refPoint.x + (dy + symbol.height) * symbol.scale * Math.cos(symbol.rot - Math.PI / 2), y: refPoint.y + (dy + symbol.height) * symbol.scale * Math.sin(symbol.rot - Math.PI / 2) });
    // points.push({ x: refPoint.x + (dy + symbol.height) * symbol.scale * Math.cos(symbol.rot - Math.PI / 2) + (dx + symbol.width) * symbol.scale * Math.cos(symbol.rot), y: refPoint.y + (dy + symbol.height) * symbol.scale * Math.sin(symbol.rot - Math.PI / 2) + (dx + symbol.width) * symbol.scale * Math.sin(symbol.rot) });
    // points.push({ x: refPoint.x + (dx + symbol.width) * symbol.scale * Math.cos(symbol.rot), y: refPoint.y + (dx + symbol.width) * symbol.scale * Math.sin(symbol.rot) });
    // points.push({ x: (points[0].x + points[2].x) / 2, y: (points[0].y + points[2].y) / 2 })
    const relp1: Point2d = { x: -symbol.width / 2 * symbol.scale, y: symbol.height / 2 * symbol.scale }
    const relp2: Point2d = { x: -symbol.width / 2 * symbol.scale, y: -symbol.height / 2 * symbol.scale }
    const relp3: Point2d = { x: symbol.width / 2 * symbol.scale, y: -symbol.height / 2 * symbol.scale }
    const relp4: Point2d = { x: symbol.width / 2 * symbol.scale, y: symbol.height / 2 * symbol.scale }
    //const l = Math.hypot(symbol.height, symbol.width);

    //  cos alpha    -sin alpha
    //
    //  sina alpha   cos alpha

    const cosAlpha = Math.cos(symbol.rot);
    const sinAlpha = Math.sin(symbol.rot);

    const newrelp1: Point2d = { x: cosAlpha * relp1.x - sinAlpha * relp1.y, y: sinAlpha * relp1.x + cosAlpha * relp1.y};
    const newrelp2: Point2d = { x: cosAlpha * relp2.x - sinAlpha * relp2.y, y: sinAlpha * relp2.x + cosAlpha * relp2.y};
    const newrelp3: Point2d = { x: cosAlpha * relp3.x - sinAlpha * relp3.y, y: sinAlpha * relp3.x + cosAlpha * relp3.y};
    const newrelp4: Point2d = { x: cosAlpha * relp4.x - sinAlpha * relp4.y, y: sinAlpha * relp4.x + cosAlpha * relp4.y};
    const newdxdy: Point2d = { x: cosAlpha * dx - sinAlpha * dy, y: sinAlpha * dx + cosAlpha * dy};

    points.push({ x: newrelp1.x + symbol.x + newdxdy.x, y: newrelp1.y + symbol.y + newdxdy.y });
    points.push({ x: newrelp2.x + symbol.x + newdxdy.x, y: newrelp2.y + symbol.y + newdxdy.y });
    points.push({ x: newrelp3.x + symbol.x + newdxdy.x, y: newrelp3.y + symbol.y + newdxdy.y });
    points.push({ x: newrelp4.x + symbol.x + newdxdy.x, y: newrelp4.y + symbol.y + newdxdy.y });
    points.push({ x: (points[0].x + points[2].x) / 2, y: (points[0].y + points[2].y) / 2 })
    return points;
}

export class Symbol {
    // draw functions
    //static render(context: CanvasRenderingContext2D, image: ImageShape, isSelected: boolean, imgLib: { url: string, img: string }[]) {
    static render(symbol: SymbolShape, isSelected: boolean, lineTypes: LineType[]) {
        const t = new Transform(symbol.transformation);
        const img = GlobalImageRepository.getImage(symbol.imageKey);
        if (!img) {
            console.log("img not found: ", symbol.imageKey);
            return [];
        }

        const refPoint = t.point2d({ x: symbol.x, y: symbol.y });
        const drawOptions:DrawOptions = {}
        sharedEditorCanvas.current.drawImage(refPoint, symbol.rot, img, img.width * symbol.scale, img.height * symbol.scale, drawOptions, symbol.anchor);

        let hotspots: Hotspot2d[] = [];
        // console.log(symbol.rot);
        if (isSelected) {
            const refPoints = calcRefPoints(symbol);
            hotspots.push({ x: refPoints[0].x, y: refPoints[0].y, type: symbol.type, shapeId: symbol.id, innerId: 0 });
            hotspots.push({ x: refPoints[1].x, y: refPoints[1].y, type: symbol.type, shapeId: symbol.id, innerId: 1 });
            hotspots.push({ x: refPoints[2].x, y: refPoints[2].y, type: symbol.type, shapeId: symbol.id, innerId: 2 });
            hotspots.push({ x: refPoints[3].x, y: refPoints[3].y, type: symbol.type, shapeId: symbol.id, innerId: 3 });
            hotspots.push({ x: refPoints[4].x, y: refPoints[4].y, type: symbol.type, shapeId: symbol.id, innerId: 4 });

            if (Global.SHOW_HIT_AREA) {
                console.log("drawing hit area")
                const opts: DrawOptions = {
                    color: "Lime",
                    lineStyle: [10, 10],
                    width: 1,

                }
                sharedEditorCanvas.current.drawPolyLine([...refPoints.slice(0, -1), refPoints[0]], opts);
            }
        }

        return hotspots;
    }

    static isHit(symbol: SymbolShape, p: Point2d) {
        let inside = false;
        const points = calcRefPoints(symbol).slice(0, -1);

        console.log(symbol, points, p.x, p.y, symbol.height, symbol.width)
        for (let i = 0, j = points.length - 1; i < points.length; j = i++) { // ignoring the last point which is in the center
            const xi = points[i].x, yi = points[i].y;
            const xj = points[j].x, yj = points[j].y;

            const intersect = ((yi > p.y) !== (yj > p.y)) &&
                            (p.x < (xj - xi) * (p.y - yi) / (yj - yi + 1e-10) + xi);
            if (intersect) inside = !inside;
        }
        console.log(inside)
        return inside;
    }

    static assembleShapeToInsert<L>(shape: L): L {
        return shape;
    }

    static _calcParams(refPoint1: Point2d, refPoint2: Point2d, width: number) : { rot: number, scale: number } {
        const scale = Math.sqrt(Math.pow(refPoint1.x - refPoint2.x, 2) + Math.pow(refPoint1.y - refPoint2.y, 2)) / (width as number);
        //const rot = Math.atan2(refPoint1.y - refPoint2.y, refPoint2.x - refPoint1.x);
        const rot = angleBetween({ x: 1, y: 0 }, subtract(refPoint2, refPoint1));

        return { rot, scale }
    }

}

const ImageCreateHandlers: ShapeInteractionHandlers<SymbolRubberData, SymbolShape> = {
    rubberInputInit: (shape: SymbolShape): SymbolRubberData => {
        const newRubberData: SymbolRubberData = {
            points: [],
            imageKey: shape.imageKey,
            rot: 1,
            scale: 1,
            finished: false,
            anchor: shape.anchor ?? { vertical: "top", horizontal: "left" }
        }
        return newRubberData;
    },
    rubberInputRenderer: (rubberPointData: SymbolRubberData, cursorPosition: Point2d) => {
        const dotDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_COLOR,
            fillColor: Global.DEFAULT_RUBBERLINE_DOT_FILL_COLOR,
        }

        rubberPointData.points.forEach(p => {
            sharedRubberCanvas.current.drawCircle(p, 5, dotDrawOptions);
        });

        const img = GlobalImageRepository.getImage(rubberPointData.imageKey);
        if (!img) {
            return;
        }

        if (rubberPointData.points.length === 0) {
            const imgDrawOptions: DrawOptions = {};
            //sharedRubberCanvas.current.drawImage(cursorPosition, 0, img, (img.width as number) * sharedPointMapperRef.current.zoom, (img.height as number) * sharedPointMapperRef.current.zoom, imgDrawOptions);
            sharedRubberCanvas.current.drawImage(cursorPosition, 0, img, img.width, img.height, imgDrawOptions, rubberPointData.anchor);
        }

        if (rubberPointData.points.length > 0) {
            const lineDrawOptions: DrawOptions = {
                width: Global.DEFAULT_RUBBERLINE_WIDTH,
                color: Global.DEFAULT_RUBBERLINE_COLOR,
            }
            const points = [rubberPointData.points[0], cursorPosition];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);

            const { rot/*, scale*/ } = Symbol._calcParams(rubberPointData.points[0], cursorPosition, img.width);

            const imgDrawOptions: DrawOptions = {};
            sharedRubberCanvas.current.drawImage(rubberPointData.points[0], rot, img, img.width, img.height, imgDrawOptions, rubberPointData.anchor);
        }
    },
    rubberInputUpdater: (rubberPointData: SymbolRubberData, cursorPosition: Point2d) : SymbolRubberData => {
        const img = GlobalImageRepository.getImage(rubberPointData.imageKey);
        if (!img) {
            return rubberPointData;
        }

        let rot = 0;
        /*let scale = 1;*/
        if (rubberPointData.points.length > 0) {
            const res = Symbol._calcParams(rubberPointData.points[0], cursorPosition, img.width);
            rot = res.rot;
            /*scale = res.scale;*/
        }
        rubberPointData.points = [...rubberPointData.points, cursorPosition];
        rubberPointData.finished = rubberPointData.points.length === 2;
        rubberPointData.rot = rot;
        rubberPointData.scale = 1; //Image._scale;

        return rubberPointData;
    },
    callback: (shape: SymbolShape, rubberPointData: SymbolRubberData) : GeometricShape => {
        //todo: clean this up..
        const img = GlobalImageRepository.getImage(rubberPointData.imageKey);
        console.log("creating img with", img);
        if (!img) {
            return shape;
        }
        return Symbol.assembleShapeToInsert<SymbolShape>({
            ...shape,
            id: 0,
            strokeWidth: strokeCorrection(shape.strokeWidth, sharedPointMapperRef.current.zoom),
            x: rubberPointData.points[0].x,
            y: rubberPointData.points[0].y,
            rot: rubberPointData.rot,
            scale: rubberPointData.scale,
            imageKey: rubberPointData.imageKey,
            width: img.width,
            height: img.height,
        });
    },
}

const ImageMoveHandlers: ShapeInteractionHandlers<SymbolRubberData, SymbolShape> = {
    rubberInputInit: (shape: SymbolShape): SymbolRubberData => {
        console.log("move it")
        let rubberData: SymbolRubberData = {
            points: [],
            imageKey: shape.imageKey,
            finished: false,
            rot: shape.rot,
            scale: shape.scale,
            anchor: shape.anchor,
        };
        rubberData.points.push({ x: shape.x, y: shape.y});
        rubberData.points.push({ x: shape.x + shape.height * shape.scale * Math.cos(shape.rot - Math.PI / 2), y: shape.y + shape.height * shape.scale * Math.sin(shape.rot - Math.PI / 2) });
        rubberData.points.push({ x: shape.x + shape.height * shape.scale * Math.cos(shape.rot - Math.PI / 2) + shape.width * shape.scale * Math.cos(shape.rot), y: shape.y + shape.height * shape.scale * Math.sin(shape.rot - Math.PI / 2) + shape.width * shape.scale * Math.sin(shape.rot) });
        rubberData.points.push({ x: shape.x + shape.width * shape.scale * Math.cos(shape.rot), y: shape.y + shape.width * shape.scale * Math.sin(shape.rot) });

        return rubberData;
    },
    rubberInputRenderer: (rubberPointData: SymbolRubberData, cursorPosition: Point2d) => {
        const dotDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_COLOR,
            fillColor: Global.DEFAULT_RUBBERLINE_DOT_FILL_COLOR,
        }

        //if (rubberPointData.points.length === 0) return;

        for (let i = 0; i < 4; ++i) {
            sharedRubberCanvas.current.drawCircle(rubberPointData.points[i], 5, dotDrawOptions);
        }

        let lineDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_COLOR,
            lineStyle: Global.LINE_SOLID,
        }
        if (rubberPointData.points.length > 4) {
            const p1 = { x: rubberPointData.points[0].x + cursorPosition.x - rubberPointData.points[4].x, y: rubberPointData.points[0].y + cursorPosition.y - rubberPointData.points[4].y }
            const p2 = { x: rubberPointData.points[1].x + cursorPosition.x - rubberPointData.points[4].x, y: rubberPointData.points[1].y + cursorPosition.y - rubberPointData.points[4].y }
            const p3 = { x: rubberPointData.points[2].x + cursorPosition.x - rubberPointData.points[4].x, y: rubberPointData.points[2].y + cursorPosition.y - rubberPointData.points[4].y }
            const p4 = { x: rubberPointData.points[3].x + cursorPosition.x - rubberPointData.points[4].x, y: rubberPointData.points[3].y + cursorPosition.y - rubberPointData.points[4].y }
            let points = [p1, p2, p3, p4, p1];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            //sharedRubberCanvas.current.drawPolyLine(rubberPointData.points, lineDrawOptions);
            lineDrawOptions.lineStyle = Global.LINE_DOTTED;
            points = [rubberPointData.points[4], cursorPosition];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
        }
    },
    rubberInputUpdater: (rubberPointData: SymbolRubberData, cursorPosition: Point2d) : SymbolRubberData => {
        console.log("updating position ", rubberPointData.points.length);
        if (rubberPointData.points.length === 4) {
            rubberPointData.points.push(cursorPosition);
            rubberPointData.finished = false;
            return rubberPointData;
        }
        if (rubberPointData.points.length === 5) {
            rubberPointData.points.push(cursorPosition);
            rubberPointData.finished = true;
            return rubberPointData;
        }

        return rubberPointData;
    },
    callback: (shape: SymbolShape, rubberPointData: SymbolRubberData) : GeometricShape => {
        const dx = rubberPointData.points[5].x - rubberPointData.points[4].x;
        const dy = rubberPointData.points[5].y - rubberPointData.points[4].y;
        const newShape = {
            ...shape,
            x: shape.x + dx,
            y: shape.y + dy,
        }
        return newShape;
    },
}

const ImageScaleHandlers: ShapeInteractionHandlers<SymbolRubberData, SymbolShape> = {
    rubberInputInit: (shape: SymbolShape): SymbolRubberData => {
        let rubberData: SymbolRubberData = {
            points: [],
            imageKey: shape.imageKey,
            finished: false,
            rot: shape.rot,
            scale: shape.scale,
            anchor: shape.anchor
        };
        rubberData.points.push({ x: shape.x, y: shape.y});
        rubberData.points.push({ x: shape.x + shape.height * shape.scale * Math.cos(shape.rot - Math.PI / 2), y: shape.y + shape.height * shape.scale * Math.sin(shape.rot - Math.PI / 2) });
        rubberData.points.push({ x: shape.x + shape.height * shape.scale * Math.cos(shape.rot - Math.PI / 2) + shape.width * shape.scale * Math.cos(shape.rot), y: shape.y + shape.height * shape.scale * Math.sin(shape.rot - Math.PI / 2) + shape.width * shape.scale * Math.sin(shape.rot) });
        rubberData.points.push({ x: shape.x + shape.width * shape.scale * Math.cos(shape.rot), y: shape.y + shape.width * shape.scale * Math.sin(shape.rot) });

        return rubberData;
    },
    rubberInputRenderer: (rubberPointData: SymbolRubberData, cursorPosition: Point2d) => {
        const dotDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_DOT_PERIMETER_COLOR,
            fillColor: Global.DEFAULT_RUBBERLINE_DOT_FILL_COLOR,
        }

        //if (rubberPointData.points.length === 0) return;

        for (let i = 0; i < 4; ++i) {
            sharedRubberCanvas.current.drawCircle(rubberPointData.points[i], 5, dotDrawOptions);
        }

        let lineDrawOptions: DrawOptions = {
            width: Global.DEFAULT_RUBBERLINE_WIDTH,
            color: Global.DEFAULT_RUBBERLINE_COLOR,
            lineStyle: Global.LINE_SOLID,
        }
        if (rubberPointData.points.length === 5) {
            const p1 = { x: rubberPointData.points[0].x, y: rubberPointData.points[0].y }
            const p2 = { x: rubberPointData.points[1].x, y: rubberPointData.points[1].y }
            const p3 = { x: rubberPointData.points[2].x, y: rubberPointData.points[2].y }
            const p4 = { x: rubberPointData.points[3].x, y: rubberPointData.points[3].y }
            let points = [p1, p2, p3, p4, p1];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            const p5 = { x: rubberPointData.points[4].x, y: rubberPointData.points[4].y }
            lineDrawOptions.lineStyle = Global.LINE_DOTTED;
            points = [p5, cursorPosition];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
        }
        if (rubberPointData.points.length > 5) {
            const p5 = { x: rubberPointData.points[4].x, y: rubberPointData.points[4].y }
            const p6 = { x: rubberPointData.points[5].x, y: rubberPointData.points[5].y }
            //const p7 = orthogonalIntersection(p5, p6, cursorPosition);
            const p7 = cursorPosition;

            //const contourPoints = uniformScaleFromPoint(p5, p6, p7, [rubberPointData.points[0], rubberPointData.points[1], rubberPointData.points[2], rubberPointData.points[3]])
            const contourPoints = transformByScalingAndRotation(p5, p6, p7, [rubberPointData.points[0], rubberPointData.points[1], rubberPointData.points[2], rubberPointData.points[3]])
            // const p2 = { x: rubberPointData.points[1].x - (p5.x - rubberPointData.points[1].x) * scale, y: rubberPointData.points[1].y - (p5.y - rubberPointData.points[1].y) * scale }
            // const p3 = { x: rubberPointData.points[2].x + (p5.x - rubberPointData.points[2].x) * scale, y: rubberPointData.points[2].y - (p5.y - rubberPointData.points[2].y) * scale }
            // const p4 = { x: rubberPointData.points[3].x + (p5.x - rubberPointData.points[3].x) * scale, y: rubberPointData.points[3].y + (p5.y - rubberPointData.points[3].y) * scale }
            let points = [...contourPoints, contourPoints[0]];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            points = [p5, p6];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
            //sharedRubberCanvas.current.drawPolyLine(rubberPointData.points, lineDrawOptions);
            lineDrawOptions.lineStyle = Global.LINE_DOTTED;
            points = [p5, p7, cursorPosition];
            sharedRubberCanvas.current.drawPolyLine(points, lineDrawOptions);
        }
    },
    rubberInputUpdater: (rubberPointData: SymbolRubberData, cursorPosition: Point2d) : SymbolRubberData => {
        console.log("updating position ", rubberPointData.points.length);
        if (rubberPointData.points.length === 4) {
            rubberPointData.points.push(cursorPosition);
            rubberPointData.finished = false;
            return rubberPointData;
        }
        if (rubberPointData.points.length === 5) {
            rubberPointData.points.push(cursorPosition);
            rubberPointData.finished = false
            return rubberPointData;
        }
        if (rubberPointData.points.length === 6) {
            const p5 = { x: rubberPointData.points[4].x, y: rubberPointData.points[4].y }
            const p6 = { x: rubberPointData.points[5].x, y: rubberPointData.points[5].y }
            //const p7 = orthogonalIntersection(p5, p6, cursorPosition);
            const p7 = cursorPosition;

            const points = transformByScalingAndRotation(p5, p6, p7, [rubberPointData.points[0], rubberPointData.points[3]]);
            let newscale = 1;
            newscale = length(subtract(p7, p5)) / length(subtract(p6, p5));
            let newrot = angleBetween({ x: 1, y: 0 }, subtract(points[1], points[0]));
            rubberPointData.scale *= newscale;
            rubberPointData.rot = newrot;

            //const contourPoints = uniformScaleFromPoint(p5, p6, p7, [rubberPointData.points[0], rubberPointData.points[1], rubberPointData.points[2], rubberPointData.points[3]])
            rubberPointData.points = transformByScalingAndRotation(p5, p6, p7, [rubberPointData.points[0]]);

            rubberPointData.finished = true
            return rubberPointData;
        }

        return rubberPointData;
    },
    callback: (shape: SymbolShape, rubberPointData: SymbolRubberData) : GeometricShape => {
        const newShape = {
            ...shape,
            x: rubberPointData.points[0].x,
            y: rubberPointData.points[0].y,
            scale: rubberPointData.scale,
            rot: rubberPointData.rot,
        }
        return newShape;
    },
}

hitManager.register("symbol", Symbol.isHit);
registerInteractionHandlers("symbol", "create", ImageCreateHandlers);
registerInteractionHandlers("symbol", "move", ImageMoveHandlers);
registerInteractionHandlers("symbol", "scale", ImageScaleHandlers);